import { styled } from "styled-components";

export const FilterSourcesForm = styled.form`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
`;

export const FormFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
`;

export const FormButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 1rem;
`;
